import axios from 'axios';

// Create a configured Axios instance
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URI || 'https://eurotalenthub.com/api',
    timeout: 15000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

/**
 * Extracts a human-friendly error message from an Axios error or generic error
 */
export const getErrorMessage = (error) => {
    if (!error) return 'An unexpected error occurred.';

    if (error.response) {
        // The server responded with a status code outside the 2xx range
        const status = error.response.status;
        const data = error.response.data;

        if (status === 404) {
            return data?.message || 'The requested resource was not found (404).';
        }
        if (status === 401 || status === 403) {
            return data?.message || 'You are not authorized to perform this action.';
        }
        if (status >= 500) {
            return 'Server error. Please try again later or contact support.';
        }

        return data?.message || data?.error || `Request failed with status ${status}.`;
    }

    if (error.request) {
        // Request was made but no response was received (Network down, CORS issue, Timeout)
        return 'Network error: Unable to reach the server. Please check your internet connection.';
    }

    return error.message || 'An unexpected error occurred.';
};

export default apiClient;

